<template>
  <div>{{ displayMessage }}</div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component({
  name: 'WaitingProgress',
})
@Component
export default class ProgressBar extends Vue {
  @Prop({ default: 'Waiting Progress' }) message!: string;
  // State
  dots = '';
  timer: ReturnType<typeof setInterval> | null = null;

  mounted(): void {
    this.startWaitingProgress();
  }

  /**
   * Memulai animasi titik pada pesan.
   */
  startWaitingProgress() {
    this.clearTimer(); // Pastikan timer lama dibersihkan
    this.timer = setInterval(() => {
      if (this.dots.length >= 3) {
        this.dots = ''; // Reset ke 0 titik jika sudah 3 titik
      } else {
        this.dots += '.'; // Tambahkan 1 titik
      }
    }, 1000);
  }

  /**
   * Menghentikan animasi titik pada pesan.
   */
  stopWaitingProgress() {
    this.clearTimer();
    this.dots = ''; // Bersihkan titik
  }

  /**
   * Membersihkan timer.
   */
  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /**
   * Lifecycle hook: Bersihkan timer saat komponen dihancurkan.
   */
  beforeUnmount() {
    this.clearTimer();
  }

  get displayMessage() {
    return `${this.message}${this.dots}`; // Gabungkan pesan utama dengan titik
  }
}
</script>
